<script>
  import SongkickWidget from "../Components/SongkickWidget.svelte";
  import Footer from "../Components/Footer.svelte";
  import Title from "../Components/Title.svelte";
  import { useFocus } from "svelte-navigator";
  const focus = useFocus();

</script>

<svelte:head>
  <meta name="description"
  content="Find Country Cruel live shows near you. Discover Country Cruel on Songkick.">
  <title>Shows - Country Cruel</title>
</svelte:head>
<h2 use:focus>Shows</h2>
<main>
  <SongkickWidget />
  <Title />

</main>
<Footer />
